import { render, staticRenderFns } from "./Lus.vue?vue&type=template&id=16fd356d&"
import script from "./Lus.vue?vue&type=script&lang=js&"
export * from "./Lus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports